import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

@Component({
  selector: 'redeem-points-badge',
  imports: [],
  templateUrl: './redeem-points-badge.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'preset-title-5 text-primary-900 flex shrink-0 items-center gap-1 rounded-full border-2 bg-white px-2 py-1',
    '[class.border-danger-900]': 'points() < 0',
    '[class.border-green]': 'points() >= 0'
  }
})
export class RedeemPointsBadge {
  points = input.required<number>()

  absPoints = computed(() => Math.abs(this.points()))
}
